module.exports = __webpack_public_path__ + "img/20.5171c964.svg";